export default __webpack_public_path__ + "static/media/centroIcon.9f2e8e3a.jpg";